import React from 'react';
import './QuizCard.css';
import { Button } from '@material-ui/core';

function QuizCard({ title, vector, description, buttonText, ...props }) {
	return (
		<div className="quizCard">
			<div className="quizCard__title">{title}</div>
			<img src={vector} alt="vector" className="quizCard__vector" />
			<div className="quizCard__description">{description}</div>
			<Button onClick={props.onClick} className="quizCard__button">
				{buttonText || "Take Test"}
			</Button>
		</div>
	);
}

export default QuizCard;
